<edl-floating-label-container label="Title" [for]="'title-' + questionId" class="mb-2">
    <input [id]="'title-' + questionId" type="text" class="form-control" placeholder="Insert short title here" formControlName="title" />
</edl-floating-label-container>
<hr />
<edl-floating-label-container label="Context type" [for]="contextTypeId">
    <select [id]="contextTypeId" class="form-select" formControlName="contextType">
        <option [value]="ContextInfoCustomFormType.BUILDING">Building</option>
        <option [value]="ContextInfoCustomFormType.EVALUATOR">Supervisor Name</option>
        <option [value]="ContextInfoCustomFormType.TARGET">Employee Name</option>
        <option [value]="ContextInfoCustomFormType.START_DATE">Start Date</option>
        <option [value]="ContextInfoCustomFormType.COMPLETED_DATE">Completed Date</option>
    </select>
</edl-floating-label-container>

